import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { retrieveProfileData, updateChitStatus, updateGoldChitSettlement, updateInstallmentPayment } from "../../api/PupilApi";
import { v4 as uuidv4 } from 'uuid';

// Add this new component for withdrawal status form
function WithdrawalStatusForm({ plan, onSave, onCancel }) {
  const [withdrawalData, setWithdrawalData] = useState({
    status: '',
    withdrawalDate: new Date().toISOString().split('T')[0],
    notes: '',
    paidAmount: '',
    settledGoldGram: '',
    proofLink: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWithdrawalData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="bg-gradient-to-br from-orange-50 to-red-50 p-4 rounded-xl border border-orange-100 shadow-sm mt-4">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-2 h-6 bg-gradient-to-r from-orange-500 to-red-500 rounded-full"></div>
        <h4 className="font-semibold text-lg text-gray-800">Update Settlement Status</h4>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
          <select
            name="status"
            value={withdrawalData.status}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
          >
            <option value="">Select Status</option>
            <option value="fullSettlement">Full Settlement</option>
            <option value="partialSettlement">Partially settled</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Settlement Date</label>
          <input
            type="date"
            name="withdrawalDate"
            value={withdrawalData.withdrawalDate}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Gold Gram</label>
          <input
            type="number"
            name="settledGoldGram"
            value={withdrawalData.settledGoldGram}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
            placeholder="Gold gram settled to customer"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Amount settled</label>
          <input
            type="number"
            name="paidAmount"
            value={withdrawalData.paidAmount}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
            placeholder="Amount paid to customer"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
          <input
            type="text"
            name="notes"
            value={withdrawalData.notes}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
            placeholder="Additional notes..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Proof Drive Link</label>
          <input
            type="text"
            name="proofLink"
            value={withdrawalData.proofLink}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
            placeholder="Link to proof of payment..."
          />
        </div>
      </div>

      <div className="flex gap-2">
        <button
          className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-4 py-2 rounded-lg font-medium flex-1"
          onClick={() => onSave(withdrawalData)}
        >
          💾 Save Withdrawal
        </button>
        <button
          className="bg-gradient-to-r from-gray-400 to-gray-500 hover:from-gray-500 hover:to-gray-600 text-white px-4 py-2 rounded-lg font-medium flex-1"
          onClick={onCancel}
        >
          ✕ Cancel
        </button>
      </div>
    </div>
  );
}

function UpdateStatusForm({ plan, onSave, onCancel }) {
  const [status, setStatus] = useState(plan.planStatus || "");

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100 shadow-sm">
      <div className="flex flex-col sm:flex-row gap-3 items-center">
        <div className="flex-grow w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">Update Status</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
          >
            <option value="">Select Status</option>
            <option value="approved">✅ Approved</option>
            <option value="rejected">❌ Rejected</option>
          </select>
        </div>
        <div className="flex gap-2 w-full sm:w-auto">
          <button
            className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-3 rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-200 flex-grow sm:flex-grow-0"
            onClick={() => onSave(status)}
          >
            💾 Save
          </button>
          <button
            className="bg-gradient-to-r from-gray-400 to-gray-500 hover:from-gray-500 hover:to-gray-600 text-white px-6 py-3 rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-200 flex-grow sm:flex-grow-0"
            onClick={onCancel}
          >
            ✕ Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

function PaymentEditForm({ installment, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    installmentNumber: installment.installmentNumber,
    paidAmount: installment.paidAmount || installment.installmentAmount || 0,
    modeOfTransaction: installment.modeOfTransaction || 'accountpay',
    paidDate: installment.paidDate || '',
    transactionId: installment.transactionId || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-2xl border border-gray-200 shadow-lg mt-4" onSubmit={handleSubmit}>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-2 h-6 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full"></div>
        <h4 className="font-semibold text-lg text-gray-800">Edit Installment #{installment.installmentNumber}</h4>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Paid Amount</label>
          <input
            name="paidAmount"
            type="number"
            min="0"
            value={formData.paidAmount}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
            required
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Payment Method</label>
          <select
            name="modeOfTransaction"
            value={formData.modeOfTransaction}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
            required
          >
            <option value="accountpay">Account Pay</option>
            <option value="creditcard">Credit Card</option>
            <option value="wallet">Wallet</option>
            <option value="cash">Cash</option>
          </select>
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Paid Date</label>
          <input
            name="paidDate"
            type="date"
            value={formData.paidDate}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
            required
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Transaction Description</label>
          <input
            name="transactionId"
            type="text"
            value={formData.transactionId}
            onChange={handleChange}
            className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
            required
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <button
          type="submit"
          className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-3 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all duration-200 flex-grow"
        >
          💳 Save Payment
        </button>
        <button
          type="button"
          className="bg-gradient-to-r from-gray-400 to-gray-500 hover:from-gray-500 hover:to-gray-600 text-white px-6 py-3 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all duration-200 flex-grow"
          onClick={onCancel}
        >
          ↶ Cancel
        </button>
      </div>
    </form>
  );
}

const ProfileView = () => {
  const { email } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editPlanId, setEditPlanId] = useState(null);
  const [selectedPlanForPayment, setSelectedPlanForPayment] = useState(null);
  const [settlementPlanId, setSettlementPlanId] = useState(null); // Fixed variable name
  const [editInstallment, setEditInstallment] = useState(null);
  const [updatingStatus, setUpdatingStatus] = useState(false);

  useEffect(() => {
    if (!email) return;
    setLoading(true);
    retrieveProfileData(email)
      .then((res) => {
        setProfile(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch profile data.");
        setLoading(false);
      });
  }, [email]);

  const handleStatusUpdate = async (planId, newStatus) => {
    if (!newStatus) {
      alert("Please select a status");
      return;
    }

    try {
      setUpdatingStatus(true);
      await updateChitStatus(profile.pupilEmail, planId, newStatus);

      setProfile((prev) => ({
        ...prev,
        plans: prev.plans.map((p) =>
          p.planId === planId
            ? {
              ...p,
              planStatus: newStatus,
              status: newStatus.toLowerCase(),
              originalStatus: newStatus.toLowerCase()
            }
            : p
        ),
      }));

      setEditPlanId(null);
    } catch (err) {
      console.error(err);
      alert("Failed to update status");
    } finally {
      setUpdatingStatus(false);
    }
  };

  const handlePaymentUpdate = async (planId, formData) => {
    try {
      await updateInstallmentPayment(
        email,
        planId,
        formData.installmentNumber,
        formData.paidAmount,
        formData.modeOfTransaction,
        formData.paidDate,
        formData.transactionId
      );
      const res = await retrieveProfileData(email);
      setProfile(res.data);
      setEditInstallment(null);
    } catch (err) {
      alert("Failed to update payment");
    }
  };

  const handleSettlementStatus = async (planId, withdrawalData) => {
    if (!withdrawalData.status) {
      alert("Please select a settlement status");
      return;
    }

    try {
      const withdrawalRequest = {
        status: withdrawalData.status,
        withdrawalDate: withdrawalData.withdrawalDate,
        notes: withdrawalData.notes,
        paidAmount: parseFloat(withdrawalData.paidAmount) || 0,
        settledGoldGram: parseFloat(withdrawalData.settledGoldGram) || 0,
        planId: planId,
        email: email,
        proofLink: withdrawalData.proofLink
      };

      await updateGoldChitSettlement(withdrawalRequest);

      const res = await retrieveProfileData(email);
      setProfile(res.data);
      setSettlementPlanId(null);
      alert('Withdrawal status updated successfully!');
    } catch (err) {
      console.error('Error updating withdrawal:', err);
      alert('Failed to update withdrawal status');
    }
  };

  // Helper function to check if status is approved
  const isStatusApproved = (plan) => {
    const status = plan.planStatus || plan.planStatus || '';
    return status.toLowerCase() === 'approved';
  };

  // Helper function to check if settlement has been completed
  const isSettlementCompleted = (plan) => {
    const planStatus = plan.planStatus || '';
    return ['fullSettlement', 'partialSettlement'].includes(planStatus);
  };

  if (loading) return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600 text-lg">Loading profile data...</p>
      </div>
    </div>
  );

  if (error) return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-red-50 flex items-center justify-center">
      <div className="text-center p-8 bg-white rounded-2xl shadow-lg border border-red-200 max-w-md">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl">⚠️</span>
        </div>
        <h2 className="text-xl font-bold text-red-600 mb-2">Error</h2>
        <p className="text-gray-600">{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 bg-red-500 text-white px-6 py-2 rounded-lg hover:bg-red-600 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );

  if (!profile) return null;

  const plans = profile.plans || [];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Header Card */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-700 rounded-2xl shadow-2xl overflow-hidden mb-8">
          <div className="p-8 text-white">
            <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
              <div className="text-center lg:text-left">
                <h1 className="text-3xl lg:text-4xl font-bold mb-2">{profile.name || "User Profile"}</h1>
                <p className="text-blue-100 text-lg">{profile.pupilEmail}</p>
              </div>
              <button
                onClick={() => navigate(-1)}
                className="bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white px-8 py-3 rounded-xl font-semibold transition-all duration-200 border border-white/30 hover:border-white/50 shadow-lg hover:shadow-xl"
              >
                ← Back to Dashboard
              </button>
            </div>
          </div>
        </div>

        {/* Profile Info Card */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-gray-100">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-3 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
            <h2 className="text-2xl font-bold text-gray-800">Profile Information</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100">
              <div className="text-sm text-gray-600 font-medium">Email</div>
              <div className="text-lg font-semibold text-gray-800 truncate">{profile.pupilEmail}</div>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-4 rounded-xl border border-green-100">
              <div className="text-sm text-gray-600 font-medium">Mobile</div>
              <div className="text-lg font-semibold text-gray-800">{profile.pupilMobile}</div>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-violet-50 p-4 rounded-xl border border-purple-100">
              <div className="text-sm text-gray-600 font-medium">Status</div>
              <div className={`text-lg font-semibold capitalize ${profile.status === 'active' ? 'text-green-600' :
                  profile.status === 'inactive' ? 'text-red-600' :
                    'text-gray-800'
                }`}>
                {profile.status}
              </div>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-red-50 p-4 rounded-xl border border-orange-100">
              <div className="text-sm text-gray-600 font-medium">Role</div>
              <div className="text-lg font-semibold text-gray-800 capitalize">{profile.role}</div>
            </div>
          </div>
        </div>

        {/* Plans Section */}
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-3 h-8 bg-gradient-to-r from-green-500 to-teal-500 rounded-full"></div>
            <h2 className="text-2xl font-bold text-gray-800">Investment Plans</h2>
            <span className="bg-gradient-to-r from-green-500 to-teal-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              {plans.length} Plans
            </span>
          </div>

          {plans.length > 0 ? (
            <div className="grid gap-6">
              {plans.map((plan) => {
                const isApproved = isStatusApproved(plan);
                const settlementCompleted = isSettlementCompleted(plan);

                return (
                  <div key={uuidv4()} className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-6 border border-gray-200 hover:border-blue-300 transition-all duration-300 shadow-sm hover:shadow-md">
                    {/* Plan Header */}
                    <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-4">
                      <div className="flex items-center gap-3">
                        <div className="w-2 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
                        <div>
                          <h3 className="text-xl font-bold text-gray-800">{plan.planName || plan.chitTitle}</h3>
                          <p className="text-gray-600">Plan ID: {plan.planId}</p>
                        </div>
                      </div>
                      <div className="flex flex-col items-end gap-2">
                        <span className={`px-4 py-2 rounded-full text-sm font-semibold shadow-sm ${isApproved ? 'bg-green-100 text-green-800 border border-green-200' :
                            plan.planStatus === 'pending' || plan.planStatus === 'requested' ? 'bg-yellow-100 text-yellow-800 border border-yellow-200' :
                              'bg-gray-100 text-gray-800 border border-gray-200'
                          }`}>
                          {plan.planStatus || "Pending"}
                        </span>
                      </div>
                    </div>

                    {/* Plan Details */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                      <div className="bg-white p-3 rounded-lg border border-gray-200">
                        <div className="text-sm text-gray-600 font-medium">Monthly Payment</div>
                        <div className="text-lg font-bold text-blue-600">{plan.monthlyInstallment || "N/A"}</div>
                      </div>
                      <div className="bg-white p-3 rounded-lg border border-gray-200">
                        <div className="text-sm text-gray-600 font-medium">Status</div>
                        <div className="text-lg font-bold text-purple-600 capitalize">{plan.planStatus || "N/A"}</div>
                      </div>
                      <div className="bg-white p-3 rounded-lg border border-gray-200">
                        <div className="text-sm text-gray-600 font-medium">Installments</div>
                        <div className="text-lg font-bold text-green-600">{plan.installmentDetailsList?.length || 0}</div>
                      </div>
                      <div className="bg-white p-3 rounded-lg border border-gray-200">
                        <div className="text-sm text-gray-600 font-medium">Settlement</div>
                        <div className="text-lg font-bold text-orange-600 capitalize">{plan.planStatus || "None"}</div>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    {editPlanId === plan.planId ? (
                      <UpdateStatusForm
                        plan={plan}
                        onSave={(newStatus) => handleStatusUpdate(plan.planId, newStatus)}
                        onCancel={() => setEditPlanId(null)}
                      />
                    ) : settlementPlanId === plan.planId ? (
                      <WithdrawalStatusForm
                        plan={plan}
                        onSave={(withdrawalData) => handleSettlementStatus(plan.planId, withdrawalData)}
                        onCancel={() => setSettlementPlanId(null)}
                      />
                    ) : (
                      <div className="flex flex-col sm:flex-row gap-3">
                        {/* Show only Update Status button if not approved */}
                        {!isApproved && (
                          <button
                            disabled={updatingStatus}
                            className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-6 py-3 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all duration-200 flex-grow flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={() => setEditPlanId(plan.planId)}
                          >
                            {updatingStatus ? (
                              <>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                Updating...
                              </>
                            ) : (
                              <>
                                <span>⚙️</span> Update Status
                              </>
                            )}
                          </button>
                        )}

                        {/* Show both Manage Payments and Settlement buttons if approved but settlement not completed */}
                        {isApproved && !settlementCompleted && (
                          <>
                            <button
                              className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-3 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all duration-200 flex-grow flex items-center justify-center gap-2"
                              onClick={() => setSelectedPlanForPayment(plan)}
                            >
                              <span>💳</span> Manage Payments
                            </button>

                            <button
                              className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white px-6 py-3 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all duration-200 flex-grow flex items-center justify-center gap-2"
                              onClick={() => setSettlementPlanId(plan.planId)}
                            >
                              <span>💰</span> Settlement Chit Status
                            </button>
                          </>
                        )}

                        {/* Show only Manage Payments button if settlement is completed */}
                        {isApproved || settlementCompleted && (
                          <button
                            className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-3 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all duration-200 flex-grow flex items-center justify-center gap-2"
                            onClick={() => setSelectedPlanForPayment(plan)}
                          >
                            <span>💳</span> Manage Payments
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-4xl">📊</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">No Plans Found</h3>
              <p className="text-gray-500">This user doesn't have any investment plans yet.</p>
            </div>
          )}
        </div>

        {/* Installment Modal */}
        {selectedPlanForPayment && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-6xl max-h-[95vh] overflow-hidden flex flex-col animate-scaleIn">
              {/* Modal Header */}
              <div className="bg-gradient-to-r from-green-500 to-teal-600 p-6 text-white">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="text-2xl font-bold">Payment Management</h3>
                    <p className="text-green-100">{selectedPlanForPayment.planName || selectedPlanForPayment.chitTitle}</p>
                  </div>
                  <button
                    onClick={() => {
                      setSelectedPlanForPayment(null);
                      setEditInstallment(null);
                    }}
                    className="bg-white/20 hover:bg-white/30 p-2 rounded-full transition-all duration-200"
                  >
                    <span className="text-xl">✕</span>
                  </button>
                </div>
              </div>

              {/* Modal Content */}
              <div className="overflow-y-auto flex-grow p-6">
                {selectedPlanForPayment.installmentDetailsList && selectedPlanForPayment.installmentDetailsList.length > 0 ? (
                  <>
                    {/* Desktop Table */}
                    <div className="hidden lg:block">
                      <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
                        <table className="w-full">
                          <thead>
                            <tr className="bg-gradient-to-r from-gray-50 to-gray-100">
                              <th className="p-4 text-left font-semibold text-gray-700">#</th>
                              <th className="p-4 text-left font-semibold text-gray-700">Due Date</th>
                              <th className="p-4 text-left font-semibold text-gray-700">Amount</th>
                              <th className="p-4 text-left font-semibold text-gray-700">Status</th>
                              <th className="p-4 text-left font-semibold text-gray-700">Paid Date</th>
                              <th className="p-4 text-left font-semibold text-gray-700">Paid by</th>
                              <th className="p-4 text-left font-semibold text-gray-700">Actions</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200">
                            {selectedPlanForPayment.installmentDetailsList.map((inst, idx) => (
                              <React.Fragment key={idx}>
                                <tr className={`hover:bg-gray-50 transition-colors ${editInstallment?.installmentNumber === inst.installmentNumber ? "bg-blue-50" : ""}`}>
                                  <td className="p-4 font-medium text-gray-900">{inst.installmentNumber}</td>
                                  <td className="p-4 text-gray-700">{inst.dueDate || '-'}</td>
                                  <td className="p-4 font-semibold text-green-600">₹{inst.installmentAmount}</td>
                                  <td className="p-4">
                                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${inst.paymentStatus === 'paid' ? 'bg-green-100 text-green-800' :
                                        'bg-yellow-100 text-yellow-800'
                                      }`}>
                                      {inst.paymentStatus || 'pending'}
                                    </span>
                                  </td>
                                  <td className="p-4 text-gray-700">{inst.paidDate || '-'}</td>
                                  <td className="p-4 text-gray-700 capitalize">{inst.updatedBy || '-'}</td>
                                  <td className="p-4">
                                    <button
                                      className={`px-4 py-2 rounded-lg font-semibold transition-all duration-200 ${editInstallment?.installmentNumber === inst.installmentNumber
                                          ? "bg-red-500 hover:bg-red-600 text-white"
                                          : "bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white"
                                        }`}
                                      onClick={() => setEditInstallment(editInstallment?.installmentNumber === inst.installmentNumber ? null : inst)}
                                    >
                                      {editInstallment?.installmentNumber === inst.installmentNumber ? "Cancel" : "Edit"}
                                    </button>
                                  </td>
                                </tr>
                                {editInstallment?.installmentNumber === inst.installmentNumber && (
                                  <tr className="bg-blue-50">
                                    <td colSpan="7" className="p-4">
                                      <PaymentEditForm
                                        installment={editInstallment}
                                        onSave={(formData) => handlePaymentUpdate(selectedPlanForPayment.planId, formData)}
                                        onCancel={() => setEditInstallment(null)}
                                      />
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* Mobile Cards */}
                    <div className="lg:hidden space-y-4">
                      {selectedPlanForPayment.installmentDetailsList.map((inst, idx) => (
                        <div key={idx} className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-5 border border-gray-200">
                          <div className="flex justify-between items-start mb-4">
                            <div>
                              <span className="text-lg font-bold text-gray-800">Installment #{inst.installmentNumber}</span>
                              <div className="text-sm text-gray-600">Due: {inst.dueDate || '-'}</div>
                            </div>
                            <span className={`px-3 py-1 rounded-full text-xs font-semibold ${inst.paymentStatus === 'paid' ? 'bg-green-100 text-green-800' :
                                'bg-yellow-100 text-yellow-800'
                              }`}>
                              {inst.paymentStatus || 'pending'}
                            </span>
                          </div>

                          <div className="grid grid-cols-2 gap-3 mb-4">
                            <div className="bg-white p-3 rounded-xl border border-gray-200">
                              <div className="text-xs text-gray-600">Amount</div>
                              <div className="font-bold text-green-600">₹{inst.installmentAmount}</div>
                            </div>
                            <div className="bg-white p-3 rounded-xl border border-gray-200">
                              <div className="text-xs text-gray-600">Paid Date</div>
                              <div className="font-medium text-gray-800">{inst.paidDate || '-'}</div>
                            </div>
                            <div className="bg-white p-3 rounded-xl border border-gray-200">
                              <div className="text-xs text-gray-600">Method</div>
                              <div className="font-medium text-gray-800 capitalize">{inst.modeOfTransaction || '-'}</div>
                            </div>
                            <div className="bg-white p-3 rounded-xl border border-gray-200">
                              <div className="text-xs text-gray-600">Transaction</div>
                              <div className="font-medium text-xs text-gray-800 truncate">{inst.transactionId || '-'}</div>
                            </div>
                          </div>

                          <button
                            className={`w-full py-3 rounded-xl font-semibold transition-all duration-200 ${editInstallment?.installmentNumber === inst.installmentNumber
                                ? "bg-red-500 hover:bg-red-600 text-white"
                                : "bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white"
                              }`}
                            onClick={() => setEditInstallment(editInstallment?.installmentNumber === inst.installmentNumber ? null : inst)}
                          >
                            {editInstallment?.installmentNumber === inst.installmentNumber ? "✕ Cancel Edit" : "✏️ Edit Payment"}
                          </button>

                          {editInstallment?.installmentNumber === inst.installmentNumber && (
                            <div className="mt-4">
                              <PaymentEditForm
                                installment={editInstallment}
                                onSave={(formData) => handlePaymentUpdate(selectedPlanForPayment.planId, formData)}
                                onCancel={() => setEditInstallment(null)}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="text-center py-12">
                    <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                      <span className="text-3xl">💸</span>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-700 mb-2">No Installments Found</h3>
                    <p className="text-gray-500">This plan doesn't have any installment data yet.</p>
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div className="p-6 border-t border-gray-200 bg-gray-50">
                <button
                  className="w-full bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-200"
                  onClick={() => {
                    setSelectedPlanForPayment(null);
                    setEditInstallment(null);
                  }}
                >
                  Close Payment Manager
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileView;